import { PHOTO_MAX_BYTES, photoResultSchema, type FoodPhotoRecognizer } from '../../domain/health/foodPhoto'
import { readLimitedJson } from '../../domain/health/shortcutSync'

export class CloudFoodPhotoRecognizer implements FoodPhotoRecognizer {
  constructor(private readonly request: (image: string, signal: AbortSignal) => Promise<Response>) {}
  async recognize(image: Blob, signal: AbortSignal) {
    if (image.type !== 'image/jpeg' || !image.size || image.size > PHOTO_MAX_BYTES) throw new Error('请重新选择照片')
    const encoded = await new Promise<string>((resolve, reject) => {
      const reader = new FileReader()
      reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '')
      reader.onerror = () => reject(new Error('照片读取失败'))
      reader.readAsDataURL(image)
    })
    if (signal.aborted) throw new Error('已取消识别')
    const response = await this.request(encoded, signal)
    const errors: Record<number, string> = {
      401: '读取密钥无效，请到设置重新连接',
      413: '照片过大，请重新选择',
      429: '识别次数已达上限或请求过快，请稍后再试，也可手动搜索',
      422: '这张照片没能识别清楚，换张照片或手动搜索吧',
      503: '云端识别暂不可用，请稍后重试或手动搜索',
    }
    if (!response.ok) throw new Error(errors[response.status] ?? '识别失败，请重试或手动搜索')
    try { return photoResultSchema.parse(await readLimitedJson(response.body, 4096)) }
    catch { throw new Error('识别结果无效，请手动搜索') }
  }
}
